import { render, staticRenderFns } from "./StudentCategoryReport.vue?vue&type=template&id=049329d4&scoped=true"
import script from "./StudentCategoryReport.vue?vue&type=script&lang=js"
export * from "./StudentCategoryReport.vue?vue&type=script&lang=js"
import style0 from "./StudentCategoryReport.vue?vue&type=style&index=0&id=049329d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049329d4",
  null
  
)

export default component.exports